// Иконки из макетов админки (docs/design/admin), stroke = currentColor.
const P = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' } as const;

export const Icons = {
  dashboard: () => (
    <svg {...P}>
      <rect x="3" y="3" width="7" height="9" rx="2" />
      <rect x="14" y="3" width="7" height="5" rx="2" />
      <rect x="14" y="12" width="7" height="9" rx="2" />
      <rect x="3" y="16" width="7" height="5" rx="2" />
    </svg>
  ),
  trends: () => (
    <svg {...P}>
      <path d="M12 3l2.5 5.5L20 11l-5.5 2.5L12 19l-2.5-5.5L4 11l5.5-2.5z" />
    </svg>
  ),
  generations: () => (
    <svg {...P}>
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <path d="M3 15l5-5 4 4 3-3 6 6" />
    </svg>
  ),
  users: () => (
    <svg {...P}>
      <circle cx="9" cy="8" r="4" />
      <path d="M2 21a7 7 0 0 1 14 0" />
      <path d="M16 4a4 4 0 0 1 0 8M22 21a7 7 0 0 0-4-6.3" />
    </svg>
  ),
  payments: () => (
    <svg {...P}>
      <rect x="2" y="5" width="20" height="14" rx="3" />
      <path d="M2 10h20" />
    </svg>
  ),
  providers: () => (
    <svg {...P}>
      <path d="M4 7h16M4 12h16M4 17h10" />
      <circle cx="18" cy="17" r="2" />
    </svg>
  ),
  queues: () => (
    <svg {...P}>
      <path d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  ),
  partners: () => (
    <svg {...P}>
      <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
      <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
    </svg>
  ),
  moderation: () => (
    <svg {...P}>
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
    </svg>
  ),
  analytics: () => (
    <svg {...P}>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  ),
  audit: () => (
    <svg {...P}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  more: () => (
    <svg {...P}>
      <circle cx="5" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="19" cy="12" r="1.5" />
    </svg>
  ),
  play: () => (
    <svg {...P} width={16} height={16} strokeWidth={2.2}>
      <path d="M6 4l14 8-14 8z" />
    </svg>
  ),
  up: () => (
    <svg {...P} width={14} height={14}>
      <path d="M6 15l6-6 6 6" />
    </svg>
  ),
  down: () => (
    <svg {...P} width={14} height={14}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),
  trash: () => (
    <svg {...P} width={14} height={14}>
      <path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" />
    </svg>
  ),
  logout: () => (
    <svg {...P}>
      <path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 17l5-5-5-5M15 12H3" />
    </svg>
  ),
};

export type IconName = keyof typeof Icons;
